import Util from "@/helper/Utility.js";
export function CreditCardModel() {
    this.cardNumber = '';
    this.cardName = '';
    this.expireDate = '';
    this.securityCode = '';
    this.isDefault = false;
    
    this.getParams = () => {
        let expire = Util.isEmptyStr(this.expireDate) ? '' : this.expireDate;
        let month = "";
        let year = "";
        try {
            month = expire.substring(0,2);
            year = expire.substring(2,4);
        } catch (error) {
            console.log(error);
        }

        var params = {
            name: this.cardName,
            number: this.cardNumber,
            expiration_month: month,
            expiration_year: year,
            security_code: this.securityCode,
        }

        return params;
    };
}